module.exports = __webpack_public_path__ + "static/avatar-f21943eeb17f48ed69ceb36e05feff35.jpg";